import React from "react";
import { Alert, AlertTitle, Button } from "@mui/material";

import { Progress } from "ui";

import { useCustomWorkflow } from "fond/hooks/useCustomWorkflow";
import { useAppSelector } from "fond/utils/hooks";

const stageConfig: Record<string, { label: string }> = {
  prepare: { label: "Preparing base data" },
  analyze: { label: "Analyzing the problem" },
  lfn: { label: "Designing the LFN" },
  dfn: { label: "Designing the DFN" },
  outputs: { label: "Creating design outputs" },
  artifacts: { label: "Creating design artifacts" },
  c2s: { label: "Calculating cost to serve" },
};

interface GeneratePanelProps {
  // Flag indicating if the editing is read only
  isReadOnly?: boolean;
}

const GeneratePanel: React.FC<GeneratePanelProps> = ({ isReadOnly }) => {
  const versionId = useAppSelector((state) => state.project.versionId);
  const { workflowState, stages, runWorkflow } = useCustomWorkflow({ versionId, key: "nbn_idd_lite_generate_design" });
  const isGenerating = workflowState === "STARTING" || workflowState === "IN_PROGRESS";

  const handleGenerate = async () => {
    runWorkflow?.();
  };

  return (
    <>
      {workflowState === undefined && (
        <Alert severity="info" variant="compact" sx={{ mb: 1 }}>
          Design is ready.
        </Alert>
      )}

      {workflowState === "COMPLETE" && (
        <Alert severity="success" variant="compact" sx={{ mb: 1 }}>
          Design generated.
        </Alert>
      )}

      {workflowState === "ERROR" && (
        <Alert severity="error" variant="compact" sx={{ mb: 2 }}>
          <AlertTitle>Design generation failed</AlertTitle>
          Design could not be generated.
        </Alert>
      )}

      {stages && (isGenerating || workflowState === "ERROR") && (
        <Progress steps={stages.map(({ key, status }) => ({ ID: key, Label: stageConfig[key].label, Status: status }))} />
      )}

      {workflowState !== "COMPLETE" && (
        <Button
          fullWidth
          variant="contained"
          size="small"
          sx={{ mt: 2 }}
          disabled={!runWorkflow || isGenerating || isReadOnly}
          onClick={handleGenerate}
        >
          Generate design
        </Button>
      )}
    </>
  );
};

export default GeneratePanel;
